import * as types from './actionTypes';

const initialState = {
  resourceApprovals: [],
  jobDetailsApproval: null,
  loading: false,
  error: null,
  updateSuccess: false,
};

const resourceApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Resource Approval
    case types.FETCH_RESOURCE_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_RESOURCE_APPROVAL_SUCCESS:
      return { ...state, loading: false, resourceApprovals: action.payload.data || [] };
    case types.FETCH_RESOURCE_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update Resource Approval
    case types.UPDATE_RESOURCE_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, updateSuccess: false };
    case types.UPDATE_RESOURCE_APPROVAL_SUCCESS:
      return { ...state, loading: false, updateSuccess: true };
    case types.UPDATE_RESOURCE_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, updateSuccess: false };

    // Fetch Job Details Approval
    case types.FETCH_JOBDETAILS_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_JOBDETAILS_APPROVAL_SUCCESS:
      return { ...state, loading: false, jobDetailsApproval: action.payload.data || null };
    case types.FETCH_JOBDETAILS_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default resourceApprovalReducer;
